import { useEffect } from "react";

const TenantListPage = () => {
  useEffect(() => {
    window.document.location.assign("/sj-admin/tenants");
  }, []);

  return <></>;
};

export default TenantListPage;
